import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "dropzone", "emptyState", "fileInfo", "fileName", "fileSize", "submit"]

  connect() {
    this.updateSubmitButton()
  }

  triggerFileSelect(event) {
    event.preventDefault()
    this.inputTarget.click()
  }

  handleFileSelect(event) {
    const file = event.target.files[0]
    if (file) {
      this.displayFile(file)
    }
  }

  dragOver(event) {
    event.preventDefault()
    this.dropzoneTarget.classList.add('border-primary', 'bg-primary/5')
  }

  dragLeave(event) {
    event.preventDefault()
    this.dropzoneTarget.classList.remove('border-primary', 'bg-primary/5')
  }

  drop(event) {
    event.preventDefault()
    this.dropzoneTarget.classList.remove('border-primary', 'bg-primary/5')

    const file = event.dataTransfer.files[0]
    if (file) {
      // Set the file to the input
      const dataTransfer = new DataTransfer()
      dataTransfer.items.add(file)
      this.inputTarget.files = dataTransfer.files

      this.displayFile(file)
    }
  }

  displayFile(file) {
    this.fileNameTarget.textContent = file.name
    this.fileSizeTarget.textContent = this.formatFileSize(file.size)
    this.emptyStateTarget.classList.add('hidden')
    this.fileInfoTarget.classList.remove('hidden')
    this.updateSubmitButton()
  }

  clearFile(event) {
    event.stopPropagation()
    this.inputTarget.value = ''
    this.emptyStateTarget.classList.remove('hidden')
    this.fileInfoTarget.classList.add('hidden')
    this.updateSubmitButton()
  }

  formatFileSize(bytes) {
    if (bytes === 0) return '0 Bytes'
    const k = 1024
    const sizes = ['Bytes', 'KB', 'MB', 'GB']
    const i = Math.floor(Math.log(bytes) / Math.log(k))
    return Math.round(bytes / Math.pow(k, i) * 100) / 100 + ' ' + sizes[i]
  }

  updateSubmitButton() {
    if (this.hasSubmitTarget) {
      const hasFile = this.inputTarget.files.length > 0
      this.submitTarget.disabled = !hasFile
    }
  }
}
